import React from 'react';
import I18n from 'i18n-js';

import { RCButton } from '@reverbdotcom/cadence/components';

export default function RenewListingButton() {
  return (
    <div>
      <RCButton
        variant="muted"
        size="mini"
        title={I18n.t('discovery.listingsManagement.renewListing.button')}
      >
        {I18n.t('discovery.listingsManagement.renewListing.button')}
      </RCButton>
    </div>
  );
}
